import { useEffect, useState, useMemo } from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
export var getNodeText = function getNodeText(element) {
  return element.content.map(function (innerNode) {
    return innerNode.nodeType === "text" ? innerNode.value : "";
  }).join();
};

var createState = function createState(data, _ref) {
  var nodeTypesHierarchy = _ref.nodeTypesHierarchy;
  var usedIds = new Set();
  var stateArray = nodeTypesHierarchy.map(function (nodeType) {
    var state = new Map();
    data === null || data === void 0 ? void 0 : data.content.forEach(function (element) {
      if (nodeType === element.nodeType) {
        var text = getNodeText(element);
        var slugBase = text.toLocaleLowerCase().replace(/[^A-Za-z0-9 \s]/g, "").split(" ").join("-");

        if (slugBase.match(/^\d/)) {
          slugBase = slugBase.replace(/^[0-9]+/, "");
          slugBase = slugBase.startsWith("-") ? slugBase.replace("-", "") : slugBase;
        }

        var slug = slugBase;
        var i = 1;

        while (usedIds.has(slug)) {
          slug = "".concat(slugBase, "-").concat(i++);
        }

        usedIds.add(slug);
        state.set(element, slug);
      }
    });
    return state;
  });
  return stateArray;
};

var defaultNodeTypesHierarchy = [BLOCKS.HEADING_2];

/**
 * A hook that creates a table of content state from a rich text document.
 * @param data The rich text document to create the table of content state from.
 * @param options The options to use when creating the table of content state.
 * @returns The table of content state.
 */
var useRichTextTableOfContent = function useRichTextTableOfContent(data) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$nodeTypesHierar = _ref2.nodeTypesHierarchy,
      nodeTypesHierarchy = _ref2$nodeTypesHierar === void 0 ? defaultNodeTypesHierarchy : _ref2$nodeTypesHierar;

  var _useState = useState(function () {
    return createState(data, {
      nodeTypesHierarchy: nodeTypesHierarchy
    });
  }),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    setState(createState(data, {
      nodeTypesHierarchy: nodeTypesHierarchy
    }));
  }, [data, nodeTypesHierarchy]);
  return useMemo(function () {
    return {
      getId: function getId(node) {
        var _state$find;

        return (_state$find = state.find(function (levelState) {
          return levelState.get(node);
        })) === null || _state$find === void 0 ? void 0 : _state$find.get(node);
      },
      getMenuLevelItems: function getMenuLevelItems(level) {
        return Array.from(state[level].entries());
      }
    };
  }, [state]);
};

export default useRichTextTableOfContent;